import React, {useState} from 'react'
import {connect} from "react-redux";

import { PiWatchLight } from "react-icons/pi";
import {useDrag} from "react-dnd";
import {send_ac_cmd, send_edit_cmd} from "../../../etc/cmd";

import {styles} from "./styles";

const AccPort = ({uid, port, root, size}) => {

    const [over, setOver] = useState(false)
    const [popOver, setPopOver] = useState([])

    const _size = size || 32

    function sel(k, n) {
        let popOverx = popOver.slice(0)
        popOverx[k] = n
        setPopOver(popOverx)
    }

    const [popup, setPopup] = useState(false);

    const [anchorPoint, setAnchorPoint] = useState({x: 0, y: 0});

    const editmode = root.editmode || false

    const _type = 'acc_port' // editmode ? 'acc_port' : 'nothing'
    const _total = port.acc_total
    const _total_n = _total > 0

    const [{isDragging, tmp}, drag, dragPreview] = useDrag(() => ({
        type: _type,
        item: {
            id: uid,
            type: 'acc_port',
            acc_addr: uid,
            acc_port: port.acc_port,
        },
        end: (item, monitor) => {
            const dropResult = monitor.getDropResult()
            if (item && dropResult) {
                if (item.type === "acc_port") {
                    let target = {}
                    target.id = dropResult.id
                    target.addr = item.acc_addr
                    target.port = item.acc_port
                    send_edit_cmd(target)
                }
            }
        },
        /*canDrag: function (props, monitor) {
            return editmode
        },*/
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
            tmp: monitor.canDrag(),
        })
    }))

    const acc_wait = port.acc_wait !== 0

    function get_asp() {
        let ret = []
        for (let k = 0; k < _total; k++) {
            ret.push(<div>k</div>)
        }
    }

    function acc(state) {
        popOver.forEach((x, i) => popOver[i] = false);
        setPopup(false)

        const cc = {
            addr: uid,
            port: parseInt(port.acc_port),
            wanted: state
        }
        send_ac_cmd(cc);
    }

    function ktotal(e) {
        const rect = e.target.getBoundingClientRect();
        setAnchorPoint({x: rect.x, y: rect.y});
        setPopup(true)
    }

    let totals = [];
    for (let k = 0; k < _total; k++) {
        totals.push(
            <div
                key={"totals_"+k}
                onClick={() => acc(k)}
                onMouseEnter={() => sel(k, true)}
                onMouseOut={() => sel(k, false)}
                style={{
                    background: '#d0bf8a', // popOver[k]?'#75683f':'#d0bf8a',
                    height: _size,
                    width: _size,
                    marginTop: '5px',
                    opacity: popOver[k] ? 0.8 : 1,
                    border: '1px solid #333333',
                    color: '#333333',
                }}
            >{k}</div>
        )
    }

    const style = {
        background: '#d0bf8a', //acc_wait ? '#b2a374' : '#d0bf8a',
        //color: !_total_n && "#797965",
        height: _size,
        width: _size,
        opacity: over && _total_n ? 0.8 : 1,
        display: acc_wait?'flex':'block',

        fontWeight: _size > 32 ? 'bold' : 'normal',
    };

    const portstyle = {
        marginLeft: '5px',
    }

    function renderDetail() {
        const ret = []
        if( !acc_wait || !_total_n) {
            ret.push(<div key={'kp'} style={portstyle}>{port.acc_port}</div>)
            if(_total_n) {
                ret.push(<div key={'ks'} style={portstyle}>{port.acc_state}</div>)
            }
        } else {
            ret.push(<div key={'hs'}>{_total_n?<PiWatchLight/>:null}</div>)
                }
        return ret
    }

    return (
        <>
        {_total > 2 && popup ?
                <div
                    key={'hh'}
                    style={{
                    zIndex: 1,
                    position: 'fixed',
                    top: anchorPoint.y + _size,
                    left: anchorPoint.x,
                    width: _size,
                }}
                    onMouseLeave={() => { setOver(false); setPopup(false); }}
                >
                    {totals}
                </div> : null}

            <div
                onMouseEnter={() => setOver(true)}
                onMouseOut={() => setOver(false)}
                onMouseLeave={() => setOver(false)}
                ref={drag}
                onClick={(_total > 2) ? ((e) => ktotal(e)) : (() => acc(port.acc_state === 0 ? 1 : 0))}
                style={{...styles.io_port,...style}}>{renderDetail()}</div>
        </>
    )
}

function mapStateToProps(state, other) {
    return {root: state.root}
}

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(AccPort)